import { render } from "./TermsPage.vue?vue&type=template&id=39970452&scoped=true"
import script from "./TermsPage.vue?vue&type=script&lang=js"
export * from "./TermsPage.vue?vue&type=script&lang=js"

import "./TermsPage.vue?vue&type=style&index=0&id=39970452&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39970452"]])

export default __exports__